
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import vSelect3 from "vselect3";
import { AlarmAwaitingRestoreAdvancedFilterRule, DeviceTypeAdvancedFilterRule } from "@/types/sv-data/system-view/advanced-filters/AdvancedStatusFilterRules";
import { Getter } from 'vuex-class';

interface RequiresRestoreOptions {
	title: string,
	value: boolean
}

@Component({
	components: {
		"v-select-3": vSelect3
	}
})
export default class AlarmAwaitingRestoreAdvancedFilter extends Vue {
	@Prop(Object) value: AlarmAwaitingRestoreAdvancedFilterRule;
	@Prop(Object) deviceTypeRule: DeviceTypeAdvancedFilterRule;

	@Getter("getFeature") getFeature: (featureName: string[]) => boolean;

	public static readonly RuleIdentifier: string = "AlarmsAwaitingRestore";
	private readonly ApplicableDeviceType: number = -1;

	private isRuleApplicable: boolean = false;

	private requiresRestoreOptions: RequiresRestoreOptions[] = [
		{ title: "Yes", value: true },
		{ title: "No", value: false }
	];

	private ruleSettings: AlarmAwaitingRestoreAdvancedFilterRule = {
		filterRuleType: AlarmAwaitingRestoreAdvancedFilter.RuleIdentifier,
		areAlarmsAwaitingRestore: false,
		enabled: false
	};

	private async mounted(): Promise<void> {
		if (this.value) {
			this.ruleSettings = this.value;
		}

		// Safely check if deviceTypeRule is provided and has a `deviceType`.
		if (this.deviceTypeRule && this.deviceTypeRule.deviceType != null) {
			this.isRuleApplicable = this.deviceTypeRule.deviceType == this.ApplicableDeviceType && this.deviceTypeRule.enabled;
		}
		else {
			this.isRuleApplicable = false;
		}
	}

	private get isNonRestoredAlarmsEnabled(): boolean {
		return this.getFeature(["SystemView", "AdvancedStatusFilters", "NonRestoredAlarms"])
	}

	@Watch("deviceTypeRule", { deep: true })
	private async updateApplicability(): Promise<void> {
		if(this.deviceTypeRule && this.deviceTypeRule.deviceType != null) {
			this.isRuleApplicable = this.deviceTypeRule.deviceType === this.ApplicableDeviceType
				&& this.deviceTypeRule.enabled;
		}
		else {
			this.isRuleApplicable = false;
		}
	}

	@Watch("ruleSettings", { deep: true })
	private async ruleUpdated(): Promise<void> {
		this.$emit("input", this.ruleSettings);
	}
}
